export const queryKeys = {
  codeMasters: 'codeMasters',
  v2RshVehicleDriver: 'v2RshVehicleDriver',
  v2DriverData: 'v2DriverData',
  v1ReservationsStatus: 'v1ReservationsStatus',
  v2VehicleOperationSchedule: 'v2VehicleOperationSchedule',
  v1Drives: 'v1Drives',
  v1Offerings: 'v1Offerings',
} as const;

export type QueryKeys = keyof typeof queryKeys;
